import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=57c0aa5b&scoped=true"
import script from "./SignUpModal.vue?vue&type=script&lang=js"
export * from "./SignUpModal.vue?vue&type=script&lang=js"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&id=57c0aa5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0aa5b",
  null
  
)

export default component.exports